module.exports = __webpack_public_path__ + "img/2021_dande_kumamotojo_0928_fin_web.550082a9.jpg";